import Vue from 'vue'

import router from './router'
import App from './df702.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
import promise from 'es6-promise/auto';
import qs from 'qs';
import axios from "axios"

let instance = axios.create({
    xsrfCookieName: 'X-Token',
    xsrfHeaderName: 'X-Token',
    //测试
   //baseURL:'http://192.168.1.20:8888',
    //线上
    baseURL:'http://114.215.221.98:8088',
    timeout: 5000,

    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});
Vue.prototype.$axios = instance;
import Echarts from 'echarts'
Vue.prototype.$echarts = Echarts;
Vue.config.productionTip = false;
// 添加请求拦截器

router.beforeEach((to, from, next) => {

    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
        if ((sessionStorage.getItem('loginDengluname') && sessionStorage.getItem('loginDenglupassword'))||sessionStorage.getItem('flag')) {
            next();
        } else {
            if (localStorage.getItem("lang")) {
                if (localStorage.getItem("lang") == "en") {
                    ElementUI.Message({
                        message: 'Warm prompt, please login first to visit.！',
                        type: 'warning'
                    });
                } else {
                    ElementUI.Message({
                        message: '请先登录后访问!',
                        type: 'warning'
                    });
                }
            } else {
                ElementUI.Message({
                    message: '请先登录后访问!',
                    type: 'warning'
                });
            }

            next({
                path: '/',
                query: { redirect: to.fullPath }
            })
        }
    } else {
        next();
    }
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js